<script>
  import CounterBtn from "../buttons/CounterBtn.vue";
  import { mapGetters } from "vuex";
  export default {
    components: {
      CounterBtn,
      ListViewers: () => import("../Competitions/ListViewers.vue"),
    },
    data() {
      return {
        isLoading: true,
        yearCompetitions: [],
        expandedYear: null,
        showVisor: "",
        isTransitioning: false,
        nextYearToExpand: null,
        isDragging: false,
        startX: 0,
        scrollLeft: 0,
        hasMoved: false,
      };
    },
    computed: {
      ...mapGetters("competitions", ["getCompetition"]),
      year() {
        return this.$route.params.year;
      },
      type() {
        return this.$route.params.type;
      },
      competitionSelected() {
        return this.$route.params.id;
      },
      activeYearCompetitions() {
        if (!this.expandedYear) return [];
        const yearData = this.yearCompetitions.find((y) => y.year === this.expandedYear);
        return yearData ? yearData.competitions : [];
      },
      timelineItems() {
        const items = [];
        const yearlyImg = "https://new-web-site-bucket.s3.amazonaws.com/myspace/competitions/defaultImg.png";
        const monthlyImg = "https://new-web-site-bucket.s3.amazonaws.com/myspace/competitions/gift.png";
        const defaultImg = this.type !== "yearly" ? monthlyImg : yearlyImg;

        if (this.type === "yearly") {
          const selectedYear = parseInt(this.year);
          const yearData = this.yearCompetitions.find((y) => y.year === selectedYear);

          if (yearData) {
            yearData.competitions.forEach((competition, compIdx) => {
              items.push({
                type: "competition",
                _id: competition._id,
                name: competition.name,
                coverImage: competition.coverImage,
                images: this.competitionSelected === competition._id ? [competition.coverImage || defaultImg] : [defaultImg],
                background:
                  this.competitionSelected === competition._id
                    ? "linear-gradient(90deg, #91693A 3%, #A07A43 10%, #C8A65D 24%, #DFBF6C 31%, #B48A42 50%, #BB944C 56%, #D1B169 65%, #F3DF96 77%, #F7E59C 79%, #E6D08C 81%, #C7AA6E 85%, #AF8D57 89%, #9D7846 93%, #936B3C 96%, #906739 100%)"
                    : "#2B2D2E",
                hasNext: compIdx < yearData.competitions.length - 1,
              });
            });
          }
          return items;
        }

        this.yearCompetitions.forEach((yearData, yearIdx) => {
          const isExpanded = this.expandedYear === yearData.year;
          const hasCompetitions = isExpanded && yearData.competitions.length > 0;
          const yearImage = "https://new-web-site-bucket.s3.amazonaws.com/myspace/competitions/regaloo%20%281%29.png";

          items.push({
            type: "year",
            year: yearData.year,
            name: yearData.year.toString(),
            isExpanded: isExpanded,
            images: [isExpanded ? yearImage : defaultImg],
            background: isExpanded ? "#fff" : "#2B2D2E",
            hasNext: hasCompetitions || !!this.yearCompetitions[yearIdx + 1],
          });

          if (this.expandedYear === yearData.year) {
            yearData.competitions.forEach((competition, compIdx) => {
              items.push({
                type: "competition",
                _id: competition._id,
                name: competition.name,
                coverImage: competition.coverImage,
                images: this.competitionSelected === competition._id ? [competition.coverImage || defaultImg] : [defaultImg],
                background:
                  this.competitionSelected === competition._id
                    ? "linear-gradient(90deg, #91693A 3%, #A07A43 10%, #C8A65D 24%, #DFBF6C 31%, #B48A42 50%, #BB944C 56%, #D1B169 65%, #F3DF96 77%, #F7E59C 79%, #E6D08C 81%, #C7AA6E 85%, #AF8D57 89%, #9D7846 93%, #936B3C 96%, #906739 100%)"
                    : "#2B2D2E",
                hasNext: compIdx < yearData.competitions.length - 1 || !!this.yearCompetitions[yearIdx + 1],
              });
            });
          }
        });
        return items;
      },
      competitionButtons() {
        const yearlyImg = "https://new-web-site-bucket.s3.amazonaws.com/myspace/competitions/defaultImg.png";
        const monthlyImg = "https://new-web-site-bucket.s3.amazonaws.com/myspace/competitions/gift.png";
        const defaultImg = this.type !== "yearly" ? monthlyImg : yearlyImg;

        return this.activeYearCompetitions.map(({ _id, name, coverImage }) => ({
          _id: _id,
          name,
          images: this.competitionSelected === _id ? [coverImage || defaultImg] : [defaultImg],
          background:
            this.competitionSelected === _id
              ? "linear-gradient(90deg, #91693A 3%, #A07A43 10%, #C8A65D 24%, #DFBF6C 31%, #B48A42 50%, #BB944C 56%, #D1B169 65%, #F3DF96 77%, #F7E59C 79%, #E6D08C 81%, #C7AA6E 85%, #AF8D57 89%, #9D7846 93%, #936B3C 96%, #906739 100%)"
              : "#2B2D2E",
        }));
      },
    },
    watch: {
      type() {
        this.yearCompetitions = [];
        this.expandedYear = null;
        this.getAllYearsCompetitions();
      },
      year() {
        if (this.type === "yearly") {
          this.verifyCompetition();
        }
      },
      competitionSelected() {
        this.scrollToSelectedCompetition();
      },
    },
    methods: {
      async getAllYearsCompetitions() {
        try {
          this.isLoading = true;

          const { data = {} } = await this.$axios.get(`/contest/years`, { params: { type: this.type } });
          const { years = [] } = data;

          this.yearCompetitions = years
            .map((yearData) => ({
              year: yearData._id,
              competitions: yearData.allData || [],
            }))
            .sort((a, b) => a.year - b.year);

          if (this.year) {
            this.expandedYear = parseInt(this.year);
          } else if (this.competitionSelected) {
            const yearWithCompetition = this.yearCompetitions.find((yearData) => yearData.competitions.some((comp) => comp._id === this.competitionSelected));
            if (yearWithCompetition) {
              this.expandedYear = yearWithCompetition.year;
            }
          } else if (this.yearCompetitions.length > 0) {
            this.expandedYear = this.yearCompetitions[0].year;
          }

          this.verifyCompetition();
          this.isLoading = false;
          this.scrollToSelectedCompetition();
        } catch (error) {
          console.log(error);
          this.isLoading = false;
        }
      },
      verifyCompetition() {
        if (this.type === "yearly") {
          const selectedYear = parseInt(this.year);
          const yearData = this.yearCompetitions.find((y) => y.year === selectedYear);

          if (this.competitionSelected || !yearData || !yearData.competitions.length) {
            return;
          }

          const competitionToShow = yearData.competitions[yearData.competitions.length - 1];
          this.$router.push({ name: "CompetitionSelected", params: { id: competitionToShow._id } });
          return;
        }

        if (this.competitionSelected || !this.activeYearCompetitions.length) {
          return;
        }

        const competitionToShow = this.activeYearCompetitions[this.activeYearCompetitions.length - 1];

        this.$router.push({ name: "CompetitionSelected", params: { id: competitionToShow._id } });
      },
      toggleYear(year) {
        if (this.isTransitioning) return;

        if (this.expandedYear === year) {
          this.expandedYear = null;
          return;
        }

        if (this.expandedYear && this.expandedYear !== year) {
          this.isTransitioning = true;
          this.expandedYear = year;

          setTimeout(() => {
            this.isTransitioning = false;
          }, 650);
        } else {
          this.expandedYear = year;
        }
      },
      openVisor($event) {
        this.showVisor = $event;
      },
      showUsersView() {
        this.showVisor = "";
      },
      handleMouseDown(e) {
        const wrapper = this.$refs.timeline;
        if (!wrapper) return;

        this.isDragging = true;
        this.hasMoved = false;
        wrapper.style.cursor = "grabbing";
        wrapper.style.userSelect = "none";
        wrapper.style.scrollBehavior = "auto";
        this.startX = e.pageX - wrapper.offsetLeft;
        this.scrollLeft = wrapper.scrollLeft;
      },
      handleMouseLeave() {
        if (!this.isDragging) return;
        this.isDragging = false;
        const wrapper = this.$refs.timeline;
        if (wrapper) {
          wrapper.style.cursor = "grab";
          wrapper.style.userSelect = "auto";
          wrapper.style.scrollBehavior = "smooth";
        }
      },
      handleMouseUp() {
        this.isDragging = false;
        const wrapper = this.$refs.timeline;
        if (wrapper) {
          wrapper.style.cursor = "grab";
          wrapper.style.userSelect = "auto";
          wrapper.style.scrollBehavior = "smooth";
        }
      },
      handleMouseMove(e) {
        if (!this.isDragging) return;
        e.preventDefault();
        const wrapper = this.$refs.timeline;
        if (!wrapper) return;

        const x = e.pageX - wrapper.offsetLeft;
        const walk = (x - this.startX) * 2;

        if (Math.abs(walk) > 5) {
          this.hasMoved = true;
        }

        wrapper.scrollLeft = this.scrollLeft - walk;
      },
      handleCompetitionClick(e) {
        if (this.hasMoved) {
          e.preventDefault();
          return;
        }
      },
      scrollToSelectedCompetition() {
        this.$nextTick(() => {
          const wrapper = this.$refs.timeline;
          if (!wrapper || !this.competitionSelected) return;

          const selectedElement = wrapper.querySelector(`[href*="${this.competitionSelected}"]`);
          if (!selectedElement) return;

          const wrapperRect = wrapper.getBoundingClientRect();
          const elementRect = selectedElement.getBoundingClientRect();
          const scrollLeft = wrapper.scrollLeft;

          const elementLeftRelativeToWrapper = elementRect.left - wrapperRect.left + scrollLeft;
          const wrapperCenter = wrapper.clientWidth / 2;
          const elementCenter = selectedElement.offsetWidth / 2;

          const scrollTo = elementLeftRelativeToWrapper - wrapperCenter + elementCenter;

          wrapper.scrollTo({
            left: Math.max(0, scrollTo),
            behavior: "smooth",
          });
        });
      },
    },
    beforeMount() {
      this.getAllYearsCompetitions();
    },
    mounted() {
      this.scrollToSelectedCompetition();
    },
  };
</script>

<template>
  <section class="yearCompetition">
    <div v-if="!isLoading" class="yearCompetition__wrapper" ref="timeline" @mousedown="handleMouseDown" @mouseleave="handleMouseLeave" @mouseup="handleMouseUp" @mousemove="handleMouseMove">
      <transition-group :name="type === 'yearly' ? '' : 'timeline'" tag="div" class="yearCompetition__timeline">
        <div v-if="item.type === 'year'" v-for="(item, index) in timelineItems" class="yearCompetition__year-item" :key="`year-${item.year}`" @click="toggleYear(item.year)" @dragstart.prevent>
          <span :class="['yearCompetition__year-label', { 'yearCompetition__year-label--active': item.isExpanded }]">
            {{ item.year }}
          </span>
          <div class="yearCompetition__button">
            <CounterBtn :button="item" />
            <div class="yearCompetition__line" v-if="item.hasNext"></div>
          </div>
        </div>
        <router-link
          v-else
          :class="['yearCompetition__competition', { 'yearCompetition__competition--last': item.type === 'competition' && timelineItems[index + 1] && timelineItems[index + 1].type === 'year' }]"
          :key="`comp-${item._id}`"
          :to="{ name: 'CompetitionSelected', params: { id: item._id } }"
          @click.native="handleCompetitionClick"
          @dragstart.prevent
          draggable="false">
          <span :class="`yearCompetition__name ${item._id === competitionSelected ? 'yearCompetition__name--active' : ''}`">
            {{ item.name }}
          </span>
          <div class="yearCompetition__button">
            <CounterBtn :button="item" />
            <div class="yearCompetition__line" v-if="item.hasNext"></div>
          </div>
        </router-link>
      </transition-group>
    </div>
    <router-view></router-view>
  </section>
</template>

<style lang="scss">
  .yearCompetition {
    @include Flex(column);
    gap: $space-16;
    width: 100%;

    &__wrapper {
      display: flex;
      max-width: 100%;
      overflow-x: auto;
      overflow-y: visible;
      white-space: nowrap;
      padding-bottom: $space-8;
      cursor: grab;
      user-select: none;
      scroll-behavior: smooth;
      scrollbar-width: none;
      -ms-overflow-style: none;

      &::-webkit-scrollbar {
        display: none;
      }

      &:active {
        cursor: grabbing;
      }
    }

    &__timeline {
      display: flex;
      width: auto;
      gap: 0;
    }

    .timeline-enter-active {
      transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
    }

    .timeline-leave-active {
      transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
    }

    .timeline-enter {
      opacity: 0;
      width: 0;
      min-width: 0;
      max-width: 0;
      margin-right: 0;
    }

    .timeline-leave-to {
      opacity: 0;
      width: 0;
      min-width: 0;
      max-width: 0;
      margin-right: 0;
    }

    .timeline-move {
      transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
    }
    &__year-item {
      @include Flex(column);
      flex-shrink: 0;
      width: 80px;
      gap: $space-12;
      cursor: pointer;
      font-family: $newFont;
      text-transform: uppercase;
      transition: all 0.3s ease;
      margin-right: $space-16;

      .CounterBtn {
        width: 38px;
        height: 38px;
        box-shadow: 0px 0px 2px 0px #000;
        opacity: 0.6;
        transition: opacity 0.3s ease;
        .CounterBtn__image {
          width: 87%;
          height: 90%;
          position: unset;
        }
      }
      .yearCompetition__line {
        left: 38px;
        width: 58px;
        opacity: 0.5;
        transition: opacity 0.3s ease;
      }

      &:has(.yearCompetition__year-label--active) {
        .CounterBtn,
        .yearCompetition__line {
          opacity: 1;
        }
        .yearCompetition__line {
          width: 87px;
        }
      }
    }
    &__year-label {
      color: rgba(33, 33, 33, 0.5);
      font-weight: 600;
      font-size: 16px;
      transition: color 0.3s ease;
      max-width: 80px;
      overflow: hidden;
      text-overflow: ellipsis;

      &--active {
        color: #212121;
      }
    }
    &__competition {
      @include Flex(column);
      flex-shrink: 0;
      width: 130px;
      margin-right: $space-16;
      gap: 6px;
      font-family: $newFont;
      text-transform: uppercase;
      white-space: nowrap;
      -webkit-user-drag: none;
      -webkit-touch-callout: none;
      user-select: none;
      padding-top: 8px;
      &:hover {
        text-decoration: none;
      }

      .CounterBtn {
        width: 32px;
        height: 32px;
        box-shadow: 0px 0px 2px 0px #000;
        .CounterBtn__image {
          width: 87%;
          height: 90%;
          position: unset;
        }
      }

      .yearCompetition__line {
        left: 32px;
        top: 2px;
        width: 115px;
      }

      &--last {
        .yearCompetition__line {
          width: 86px;
        }
      }
    }

    &__name {
      width: 100%;
      text-align: center;
      font-size: 12px;
      overflow: hidden;
      text-overflow: ellipsis;
      color: rgba(33, 33, 33, 0.5);
      &--active {
        color: #212121;
      }
    }

    &__button {
      position: relative;
      margin-bottom: 2px;
    }

    &__line {
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto;
      height: 2px;
      width: 130px;
      background: linear-gradient(
        90deg,
        #91693a 3%,
        #a07a43 10%,
        #c8a65d 24%,
        #dfbf6c 31%,
        #b48a42 50%,
        #bb944c 56%,
        #d1b169 65%,
        #f3df96 77%,
        #f7e59c 79%,
        #e6d08c 81%,
        #c7aa6e 85%,
        #af8d57 89%,
        #9d7846 93%,
        #936b3c 96%,
        #906739 100%
      );
    }
  }
</style>
